<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Modèle de contrat</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <div
      class="notification is-warning is-padding-small is-marginless is-flex is-vcentered is-minH50p">
      <div class="is-self-centered has-text-centered w100 is-uppercase is-size-7">
        <b class="has-text-weight-medium">
          Vos modèles de contrat sont disponibles dans l'onglet "Document personnalisé"
        </b>
      </div>
    </div>
    <section
      class="modal-card-body is-clipped"
      :class="{'paddingbottom300': hasPadding}">
      <div class="is-margin-xlarge">
        <div class="is-padding-top is-padding-bottom-xlarge">
        </div>
        <div
          class="field">
          <div
            v-if="isMultiselect && contracts != null"
            class="control">
            <multiselect
              v-model="selectedContract"
              :options="contracts"
              :multiple="true"
              class="multiselect--option-ico"
              :searchable="true"
              value="pk"
              :placeholder="''"
              name="contracts"
              data-vv-as="Contrat"
              :close-on-select="false"
              :show-labels="false"
              label="name"
              @open="hasPadding = true"
              @close="hasPadding = false"
              track-by="pk"
              @search-change="getContracts">
              <span slot="noResult">Oups! Aucun contrat trouvé.</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Sélectionnez ou saisissez un ou plusieurs contrat(s)</span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
          <div
            v-else
            class="control">
            <multiselect
              v-model="selectedContract"
              label="name"
              track-by="pk"
              :options="contracts"
              :searchable="false"
              :show-labels="false"
              class="multiselect--option-ico is-single_choice"
              :placeholder="''"
              @open="hasPadding = true"
              @close="hasPadding = false"
              @remove="selectedContract = null">
              <span
                slot="placeholder"
                class="multiselect__placeholder">Modèle de contrat</span>
              <span
                slot="selection"
                class="multiselect__placeholder"
                slot-scope="{ values }"
                v-if="values.length">
                <span>Modèle de contrat ({{ values.length }})</span>
              </span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
        </div>
        <div class="columns is-margin-bottom-xlarge  is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
          <button
            @click="submit()"
            type="button"
            :disabled="nameExist"
            class="button is-uppercase is-fullwidth is-success">
            <span>Enregister modèle</span>
          </button>
        </div>
        <div class="is-padding-top is-padding-bottom-xlarge">
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import { cloneDeep } from 'lodash'
export default {
  name: 'ContractSelectModal',
  props: {
    source: {
      type: Object
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      hasPadding: false,
      isMultiselect: false,
      contracts: null,
      currentContract: null,
      selectedContract: null
    }
  },
  computed: {
    nameExist () {
      if (this.contractName) {
        return this.contractName.includes(this.contract.name)
      } else {
        return false
      }
    }
  },
  watch: {
  },
  async created () {
    if ('contracts' in this.source) {
      this.contracts = cloneDeep(this.source.contracts)
      this.contracts.unshift({ name: 'Contrat de Vadimm par défaut', pk: null })
    } else {
      await this.getContracts()
      this.isMultiselect = true
    }
    if (Array.isArray(this.source.currentContract)) {
      this.selectedContract = this.source.currentContract
    } else {
      this.currentContract = this.source.currentContract
      if (this.currentContract != null && this.contracts != null && this.contracts.length > 0) {
        for (let contract of this.contracts) {
          if (contract.pk === this.currentContract) {
            this.selectedContract = contract
          }
        }
      } else {
        this.selectedContract = { name: 'Contrat de Vadimm par défaut', pk: null }
      }
    }
  },
  methods: {
    async getContracts (query) {
      let params = {
        sort: 'name:asc',
        searchable_name: query,
        per_page: 200
      }
      let { data } = await this.$api.axios.get('custom-contracts', params)
      this.contracts = data.items.filter(item => item.contract_type === 'promotion')
    },
    close () {
      this.contracts = null
      this.$emit('close')
    },
    submit () {
      this.$emit('submit', this.selectedContract)
    }
  }
}
</script>

<style scoped>
  .paddingbottom300 {
    padding-bottom: 150px
  }
</style>
